module.exports = require("./de-BE.d.ts");